"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const masterData_json_1 = require("../masterData.json");
/**
 * Get the life base factor from the month, day, and coefficient.
 * @param month The month. (1-12)
 * @param dcoef Coefficient of date.
 * @returns The factors of Life base.
 */
exports.default = (month, dcoef) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = masterData_json_1.lifeBaseCoefficients[month - 1]) === null || _a === void 0 ? void 0 : _a.find((v) => { var _a; return dcoef < ((_a = v.t) !== null && _a !== void 0 ? _a : Number.MAX_VALUE); })) === null || _b === void 0 ? void 0 : _b.v) !== null && _c !== void 0 ? _c : Number.NaN;
};
//# sourceMappingURL=lifeBaseCoefficients.js.map